// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Passages extends APIResource {
    /**
     * Insert a memory into an agent's archival memory store.
     */
    create(agentID, body, options) {
        return this._client.post(path `/v1/agents/${agentID}/archival-memory`, { body, ...options });
    }
    /**
     * Retrieve the memories in an agent's archival memory store (paginated query).
     */
    list(agentID, query = {}, options) {
        return this._client.get(path `/v1/agents/${agentID}/archival-memory`, { query, ...options });
    }
    /**
     * Delete a memory from an agent's archival memory store.
     */
    delete(memoryID, params, options) {
        const { agent_id } = params;
        return this._client.delete(path `/v1/agents/${agent_id}/archival-memory/${memoryID}`, options);
    }
    /**
     * Search archival memory using semantic (embedding-based) search with optional
     * temporal filtering.
     *
     * This endpoint allows manual triggering of archival memory searches, enabling
     * users to query an agent's archival memory store directly via the API. The search
     * uses the same functionality as the agent's archival_memory_search tool but is
     * accessible for external API usage.
     */
    search(agentID, query, options) {
        return this._client.get(path `/v1/agents/${agentID}/archival-memory/search`, { query, ...options });
    }
}
//# sourceMappingURL=passages.mjs.map